export default "/pressure.d5847155-95e2c0.svg";